"use strict";

import $ from 'jquery';
import appInit from './src/script-market';

window.$=window.jQuery=$;

window.app=null;

$(function () {
    window.app=new appInit();
});